import { isFeatureEnabled } from '@sdk/utils/isFeatureEnabled';

import config from '../config';

import notificationRowUrl from './notification-row.html';

class DashboardCtrl {
  notificationRowUrl = notificationRowUrl;
  TIME_CARD_NOTES_ENABLED = config.TIME_CARD_NOTES_ENABLED;

  constructor(
    Restangular,
    Authentication,
    NotificationCollection,
    Notifications,
    Tasks,
    NotificationModal,
    TaskCollection,
    EventCollection,
    StatusService,
    TimesheetsService,
    ReactNotificationService,
    $uibModal,
    $scope,
    $rootScope,
    $state,
    $window,
    $timeout,
    extendShiftModel,
    displayMode,
    toTimeFilter,
    dateFilter
  ) {
    'ngInject';

    Object.assign(this, {
      Restangular,
      Authentication,
      NotificationCollection,
      Notifications,
      Tasks,
      NotificationModal,
      TaskCollection,
      EventCollection,
      StatusService,
      TimesheetsService,
      ReactNotificationService,
      $uibModal,
      $scope,
      $rootScope,
      $state,
      $window,
      $timeout,
      extendShiftModel,
      displayMode,
      toTimeFilter,
      dateFilter,
    });

    this._loadingAnotherPage = false;

    this.mode = this.displayMode;
    this.archived = this.displayMode === 'history';
    this.order = '-id';
    this.notification = null;
    this.FREE_USER_LIMIT_ENABLED = isFeatureEnabled(config.FREE_USER_LIMIT_ENABLED);

    if (this.mode === 'history') {
      this.order = '-archivedAt';
    }

    if (this.page === 0 && !this.currentShifts) {
      this.getCurrentShifts();
    }

    this.init();
    this.openNotificationModal = (notification) => {
      this.NotificationModal.openNotificationModal(notification);
    };

    const _focusHandler = () => {
      if (this.StatusService.unreadNotifications > 0 && !this.notificationsLoading) {
        this.NotificationCollection.readAll();
      }
    };

    const unregisterCurrentShifts = this.EventCollection.onCurrentShiftsChange(
      this.getCurrentShifts.bind(this)
    );

    $window.addEventListener('focus', _focusHandler);
    $scope.$on('$destroy', () => {
      $window.removeEventListener('focus', _focusHandler);
      unregisterCurrentShifts();
    });

    $scope.$on('socket:notification:new', () => {
      if (this.StatusService.focus) {
        this.NotificationCollection.readAll();
      }
    });

    $scope.$on('socket:reconnect', () => {
      this.init();
    });
  }

  get notifications() {
    return this.NotificationCollection.myPage;
  }

  showNextPage() {
    if (!this._loadingAnotherPage && this.notifications.length >= this.pageSize) {
      this._loadingAnotherPage = true;
      this.page++;

      return this.getNotifications(this.page).finally(() => {
        this._loadingAnotherPage = false;
        return true;
      });
    }

    return false;
  }

  showPrevPage() {
    if (!this._loadingAnotherPage && this.page > 0) {
      this._loadingAnotherPage = true;
      this.page--;

      return this.getNotifications(this.page).finally(() => {
        this._loadingAnotherPage = false;
        return true;
      });
    }

    return false;
  }

  getNotifications(page) {
    return this.NotificationCollection.getNotifications(this.archived, page).then(() => {
      this.notificationsLoading = false;
      this.deselectAllNotifications();
      this.NotificationCollection.readAll();

      return true;
    });
  }

  async getCurrentShifts() {
    if (this.EventCollection.currentShifts) {
      return this.updateCurrentShifts();
    }

    this.currentShiftsLoading = true;
    try {
      await this.EventCollection.getCurrentShifts();
      this.updateCurrentShifts();
    } finally {
      this.currentShiftsLoading = false;
    }
  }

  updateCurrentShifts() {
    this.currentShifts = this.EventCollection.currentShifts;
    if (this.currentShifts) {
      this.currentShifts = this.currentShifts.map((s) =>
        this.Restangular.restangularizeElement(null, { ...s }, 'calendar')
      );
    }
  }

  init() {
    this.notificationsLoading = true;
    this.selectedNotifications = {};
    this.selectedAll = false;
    this.page = 0;
    this.isReactNotificationModalOpen = false;
    this.pageSize = this.NotificationCollection.pageSize;
    this.tabs = [
      { value: 'notifications', label: 'notifications' },
      { value: 'roster', label: 'roster' },
    ];
    this.activeTab = this.tabs[0].value;

    this.getCurrentShifts();

    this.closeFreeUserLimitTip = function closeFreeUserLimitTip() {
      this.Authentication.user.clientsettings.freeUserLimitTipShown = true;
      this.Authentication.syncClientSettings();
    };

    return this.getNotifications(this.page);
  }

  changeTab(value) {
    this.activeTab = value;
  }

  isNotificationDismissable(notification) {
    return notification.actions.some((action) => action.type === 'neutral');
  }

  isAnyNotificationDismissable() {
    return this.notifications.some((n) => this.isNotificationDismissable(n));
  }

  selectAllNotifications() {
    this.selectedNotifications = {};

    this.notifications
      .filter((n) => n.archived === this.archived)
      .forEach((n) => {
        if (this.isNotificationDismissable(n)) {
          this.selectedNotifications[`id_${n.id}`] = true;
        }
      });
  }

  deselectAllNotifications() {
    this.selectedNotifications = {};
  }

  selectedAllChange() {
    if (this.selectedAll) {
      this.selectAllNotifications();
    } else {
      this.deselectAllNotifications();
    }
  }

  checkIfAllSelected() {
    this.selectedAll = this.notifications
      .filter((n) => n.archived === this.archived)
      .every((n) => !this.isNotificationDismissable(n) || this.selectedNotifications[`id_${n.id}`]);
  }

  dismissSelected() {
    const mapped = this.notifications
      .filter((item) => this.selectedNotifications[`id_${item.id}`] && !item.archived)
      .map((item) => ({
        id: item.id,
        archived: true,
      }));

    return this.Restangular.all('notifications')
      .customPOST(mapped)
      .then((data) => {
        if (data && Array.isArray(data)) {
          data.forEach((notification) => {
            this.NotificationCollection.addOrEditNotification(notification);
          });
        }

        this.selectedAll = false;
        this.selectedAllChange();
        return this.getNotifications(this.page);
      });
  }

  hasNotifications(archived) {
    return this.notifications.some((n) => n.archived === archived);
  }

  getNotificationClasses(notification) {
    let classes = `notification-${this.mode} notification-${notification.category} `;

    if (!notification.read) {
      classes += 'unread ';
    }

    if (this.archived) {
      classes += 'archived ';
    }

    if (this.selectedNotifications[`id_${notification.id}`]) {
      classes += 'selected ';
    }

    if (this.isNotificationDismissable(notification) && !this.archived) {
      classes += 'dismissable ';
    }

    return classes;
  }

  displayDate(date) {
    const time = this.toTimeFilter(date);
    const monthDate = this.dateFilter(date, 'EEEE • MMMM d');

    return `${time} • ${monthDate}`;
  }

  viewTimeclockNote(notification) {
    if (!notification.items?.length || !notification.items[0].assigneeNotes) {
      return;
    }

    const { assigneeNotes, date } = notification.items[0];
    this.TimesheetsService.openTimeclockNoteModal(assigneeNotes, date, notification.actor.fullname);
  }

  shouldShowNotificationDate = (notification) => notification.type !== 'announcement_received';
}

export default DashboardCtrl;
